'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { CART_COUPON_DISCOUNT_LABEL } from './cart-coupon/cart-coupon.const';

import { Button } from '@/components/ui/button/button.component';
import { currencyFormatter } from '@/utils/formatters/currency';

interface CartFooterProps {
  total: number;
  discount?: number;
  onProceed: () => void;
}

export function CartFooter({ total, discount = 0, onProceed }: CartFooterProps) {
  return (
    <footer
      className="shrink-0 bg-white p-3 shadow-modal"
      data-testid={DataTestIdEnum.CART_FOOTER}
    >
      <div className="flex items-center gap-2 rounded-xxl border border-gray-300 bg-gray-100 py-2 pl-4 pr-2">
        <div className="flex flex-1 flex-col">
          {discount > 0 && (
            <p
              className="whitespace-nowrap text-sm leading-5 text-gray-700"
              data-testid={DataTestIdEnum.CART_FOOTER_DISCOUNT}
            >
              {CART_COUPON_DISCOUNT_LABEL}
              {' '}
              <span className="font-semibold text-success-600">{`-${currencyFormatter(discount)}`}</span>
            </p>
          )}

          <p
            className="whitespace-nowrap text-lg leading-6 text-gray-800"
            data-testid={DataTestIdEnum.CART_FOOTER_TOTAL}
          >
            Total
            {' '}
            <span className="font-bold">{currencyFormatter(total)}</span>
          </p>
        </div>

        <Button
          className="w-auto shrink-0"
          data-testid={DataTestIdEnum.CART_FOOTER_PROCEED_BUTTON}
          onClick={onProceed}
        >
          Prosseguir
        </Button>
      </div>
    </footer>
  );
}
